import axios from "axios";
import router from "@/router";
import { Message, Loading } from "element-ui";
import NProgress from "nprogress"; // nprogress插件
import Qs from "qs";
import util from "@/utils";

let messageDebouncedState = true; //限制请求错误提示次数

// var host = process.env.VUE_APP_BASE_API;
let host = process.env.VUE_APP_BASE_API;
// const host = 'http://192.168.3.26:9092/hospital/'
// const host = 'http://192.168.3.11:9092/hospital/'
console.log(host);
// 创建axios的一个实例
var instance = axios.create({
  baseURL: host,
});
var loadingInstance;

// 一、请求拦截器 忽略
instance.interceptors.request.use(
  function(config) {
    loadingInstance = Loading.service({
      lock: true,
      text: "",
      spinner: "el-icon-loading",
      background: "transparent",
    });
    //开始进度条
    NProgress.start();
    // 切记位置不要发生变化
    config.headers = {
      "X-Access-Token": util.getStore("user_token"),
      // 'Content-Type': 'application/x-www-form-urlencoded'
      "Content-Type": "application/json;charset=UTF-8",
    };
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    console.log("request-error: ", error);
    setTimeout(function() {
      loadingInstance.close();
    }, 1000);
    //结束进度条
    NProgress.done();
    return Promise.reject(error);
  }
);
// 二、响应拦截器 忽略
instance.interceptors.response.use(
  function(response) {
    setTimeout(function() {
      loadingInstance.close();
    }, 1000);
    //结束进度条
    NProgress.done();
    let data = response.data;
    if (data.code === 11005) {
      util.removeStore("user_token");
      util.removeStore("userInfo");
      util.removeStore("user_mobile");
      util.removeStore("user_id");
      setTimeout(() => {
        router.replace("/login");
      }, 1500);
    }
    if (data.message === "验证码错误~") {
      return response.data; //用来刷新图形验证码
    } else if (data.code !== 200 && data.code !== 1) {
      Message({
        type: "error",
        message: data.message,
      });
      return new Promise(() => {}); //中断promise连
    } else {
      return response.data;
    }
  },
  function(error) {
    setTimeout(function() {
      loadingInstance.close();
    }, 1000);
    //结束进度条
    NProgress.done();

    return Promise.reject(error);
  }
);
export default function(method, url, data, options) {
  method = method.toLowerCase();
  if (url.indexOf("http://") === -1 && url.indexOf("https://") === -1) {
    url = util.url(url);
  }
  if (method === "post") {
    // return instance.post(url, Qs.stringify(result_param));
    return instance.post(url, data, options);
  } else if (method === "get") {
    return instance.get(url, {
      ...options,
      params: data,
    });
  } else {
    return false;
  }
}
